import React from "react"
import CMSBrowser from "aldoo-ra/CMS/browsers/cms-browser"
import TypeBrowser from "./browsers/type-browser"
import SidePanelLayout from "aldoo-ra/SidePanel"

export default function ContentTypeSystem() {
  return (
    <SidePanelLayout
      menuName="AdminCMS"
      tabs={{
        contents: CMSBrowser,
        types: TypeBrowser,
      }}
    />
  )
}
